export const coordonneesContent = {
    title: {
        site: 'Vos coordonnées',
        conseiller: 'Coordonnées du client',
        conseillermae: "Coordonnées de l'adhérent",
    },
    titleAdresse: {
        site: 'Votre adresse postale',
        conseiller: 'Adresse postale du client',
        conseillermae: "Adresse postale de l'adhérent",
    },
    telephoneLabel: {
        site: 'Téléphone portable',
    },
    emailLabel: {
        site: 'Adresse e-mail',
        courtier: 'Renseignez son adresse e-mail personnelle',
    },
    emailPlaceholder: {
        site: 'votre-email@exemple.com',
        courtier: 'son-email@exemple.com',
    },
    confirmEmailLabel: {
        site: 'Confirmez votre adresse e-mail',
        courtier: "Confirmez l'adresse e-mail",
    },
    confirmEmailPlaceholder: {
        site: 'Confirmez votre adresse e-mail',
        courtier: "Confirmez l'adresse e-mail",
    },
    emailDematerialisationNotice: {
        site: "En nous communiquant votre adresse e-mail, vous acceptez que la gestion et l'exécution de votre contrat soient réalisées par voie dématérialisée : vous pourrez y mettre un terme à tout moment et sans frais en vous rendant sur votre Espace Assuré.",
    },
    optinLabel: {
        site: "Afin d'être accompagné dans le cadre de ma démarche d'assurance, j'accepte d'être contacté par téléphone par un conseiller MAE.",
    },
    optinDescription: {
        site: "Pour vous conseiller au mieux dans le cadre de votre démarche, vous pourrez être rappelé par un conseiller APRIL d'ADM Value (N°ORIAS : 10055724).",
    },
    phoneConsentTitle: {
        site: 'Pourquoi accepter un rappel téléphonique ?',
    },
    phoneConsentDescription: {
        site: '<><p>',
    },
    phoneConsentSubtitle: {
        site: 'Nos conseillers sont là pour vous simplifier la vie :',
    },
    phoneConsentBullet1: {
        site: 'Un accompagnement personnalisé pour choisir la formule adaptée',
    },
    phoneConsentBullet2: {
        site: 'Des réponses rapides de nos experts à vos questions',
    },
    phoneConsentBullet3: {
        site: 'La garantie d\'un suivi transparent et sans engagement',
    },
    emailConsentIntro: {
        site: 'Votre devis vous attend, ne le perdez pas !',
    },
    emailConsentReceive: {
        site: 'Recevez vos informations directement par email',
    },
    emailConsentWhyTitle: {
        site: 'Pourquoi recevoir vos relances de devis par email ?',
    },
    emailConsentBullet1: {
        site: 'Retrouvez votre devis à tout moment, même plusieurs jours après',
    },
    emailConsentBullet2: {
        site: "Des rappels utiles avant l'expiration de votre tarif personnalisé",
    },
    emailConsentBullet3: {
        site: 'Vos données sont protégées : aucun spam, désabonnement possible à tout moment',
    },
} as const;
